import React from 'react';
import moment from 'moment';
import { FORMAT_NUMBER } from '../libs/utils/Const';

const renderTableBody = (headers, data, checkbox, openDetails) => {
    const body = data.map((document, index) => {
        const status = document.UUID === null ? 'Sin Timbrar' : 'Timbrado';
        return (
            <tr key={index}>
                <td class="sticky-column" >
                    <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)} />
                </td>
                <td>{status}</td>
                <td>{document?.IdNom ?? ''}</td>
                <td>{document?.RecepRfc ?? ''}</td>
                <td>{document?.RecepNombre ?? ''}</td>
                <td>{document?.UUID ?? 'Sin Folio'}</td>
                <td>{moment(document?.DocDate).format("DD-MM-YYYY") ?? 'N/A'}</td>
                <td>{FORMAT_NUMBER.new(document?.Total, ' $ ') ?? ''}</td>
                <td class="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                    <button type="button" className="btn btn-timbra-one btksn-sm botonCorrect"
                        onClick={() => openDetails(document)}
                        style={{ fontWeight: '500' }}>
                        <i class="far fa-file-alt">
                        </i> Ver Detalles
                    </button>
                </td>
            </tr>
        )

    })
    return body;
};

const renderTable = (headers, data, checkbox, openDetails) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            <td class="sticky-column" style={{ backgroundColor: "#e9ecef" }}>
                <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" value="second_checkbox" onChange={(event) => checkbox.selectAll(event.target.checked)} />
            </td>
            {headers[0].value && <td>{headers[0].title}</td>}
            {headers[1].value && <td>{headers[1].title}</td>}
            {headers[2].value && <td>{headers[2].title}</td>}
            {headers[3].value && <td>{headers[3].title}</td>}
            {headers[4].value && <td>{headers[4].title}</td>}
            {headers[5].value && <td>{headers[5].title}</td>}
            {headers[6].value && <td>{headers[6].title}</td>}
            <td class="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>

        </tr>;
    }
    body = renderTableBody(headers, data, checkbox, openDetails);
    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;
}

export const renderTableNominas = (headers, data, checkbox, openDetails) => {
    return renderTable(headers, data, checkbox, openDetails);

}   